import OpaccPopperTooltip from '../../lib/tooltip/opacc.lib.tooltip.js';

/** @module general */

/**
 * Tooltips anzeigen bei Mouse-Over
 */
export class OpaccTooltip {
	constructor() {
		this.initAll();
	}

	initAll() {
		let tooltips = document.querySelectorAll('[data-op-tooltip]');
		this.init(tooltips);
	}

	initSpecified(parentElem) {
		let tooltips = parentElem.querySelectorAll('[data-op-tooltip]');
		this.init(tooltips);
	}

	init(tooltips) {
		if (tooltips.length > 0) {
            Array.from(tooltips).forEach(item => {
                OpaccPopperTooltip(item, {
                    content: this.fixTitle(item).getAttribute('data-op-original-title'),
                    allowHTML: item.dataset.opTooltipHtml && item.dataset.opTooltipHtml=='1' ? true : false,
                    placement: item.dataset.opTooltipPlacement ? item.dataset.opTooltipPlacement : 'top',
                    delay: item.dataset.opTooltipDelay ? this.JsonStringToObj(item.dataset.opTooltipDelay) : 0
                })
            })
		}
	}

	/**
	 *
	 *
	 * @param {*} string
	 * @returns {*}
	 */
	JsonStringToObj(string) {
		let fixedJSON = string.replace(/(['"])?([a-zA-Z0-9_]+)(['"])?:/g, '"$2": ');
		return JSON.parse(fixedJSON);
	}

	/**
	 *
	 *
	 * @param {*} item
	 * @returns {*}
	 */
	fixTitle(item) {
		const titleType = typeof item.getAttribute('data-op-original-title');
		const itemTitle = item.getAttribute('title');
		if (itemTitle || titleType !== 'string') {
			if (itemTitle.trim().length > 0) {
				item.setAttribute('data-op-original-title', itemTitle || '');
				item.setAttribute('title', '');
			}
		}
		return item;
	}

	/**
	 * Initialisierung der Tooltips
	 *
	 * @param {HTMLElement} item HTML-Element, auf dem das Tooltip angezeigt werden soll
	 * @param {Object} options Objekt um die Tooltips individuell zu platzieren / formatieren
	 */
	initializeTooltips(item, options) {
        new OpaccPopperTooltip(item, options);
	}

}